// import OTPInput from "react-otp-input";
import Clickable from "../components/clickable.";
import images from "../constants/images";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../functions/api";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "../redux/slices";
import OTPInput from "react-otp-input";

const Login = () => {
    const [mobNo, setMobNo] = useState(null);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState(null);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const login = async () => {
        try {
            const data = await api.post("/admin-login", {
                mobNo,
                otp,
            });
            if (!otpSent) return setOtpSent(true);
            dispatch(setToken(data.token));
            dispatch(setUser(data._id));
            navigate("/");

            localStorage.setItem("num", mobNo);
        } catch (err) {
            console.log("🚀 ~ login ~ err:", err);
        }
    };

    useEffect(() => {
        const otpRegex = /^\d{4}$/;

        otp?.match(otpRegex) && login();
    }, [otp]);

    return (
        <div className="login">
            <div className="container">
                <div className="title">Login</div>
                <div className="text">
                    Please login with your mobile number & OTP
                </div>
            </div>

            <div className="mobile">
                <div className="input-container">
                    <div className="mobile-num">
                        <img src={images.mobile} className="mobile-icon" />
                    </div>
                    <div>
                        <input
                            className="input"
                            placeholder="Enter Your Mobile Number"
                            maxLength={10}
                            onChange={(e) => setMobNo(e.currentTarget.value)}
                            inputMode="numeric"
                        />
                    </div>
                </div>

                <Clickable
                    className="btn"
                    disabled={!mobNo || !mobNo.match(/^[6-9]\d{9}$/)}
                    onClick={login}
                >
                    Send OTP
                </Clickable>

                {otpSent && (
                    <OTPInput
                        numInputs={4}
                        value={otp}
                        onChange={(al) => setOtp(al)}
                        renderInput={(props) => (
                            <input
                                {...props}
                                className="otp-input"
                                inputMode="numeric"
                            />
                        )}
                        shouldAutoFocus
                    />
                )}
            </div>
        </div>
    );
};

export default Login;
